// extracted by css-extract-rspack-plugin
export default {"LayoutContent":"LayoutContent-apGKqT","layoutContent":"LayoutContent-apGKqT"};